import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.seek.com',
    clientDomain: 'www.seek.com.au',
    clientId: 'yGBVge66K5NJpSN5u71fU90VcTlEASNu',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.SEEK,
    contactUs: {
        en: 'https://www.seek.com.au/contact-us/',
    },
    siteName: siteNames.candidate.seek.au,
    zone: getZoneFromSite(siteNames.candidate.seek.au),
    product: Product.SEEK,
};
//# sourceMappingURL=seek_com_au.js.map